// Batch 32 · FAR-1 — the auditor overwrites a built-in expectation (e.g. the payroll run-rate) with a reason; the computed amount
// stays visible, the change can be undone. Batch 33 · FAR-F5: the change is kept on the screen and written by the screen's Save.
import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { fmt, fill } from "@/components/far/FarParts";

export default function ExpectationOverride({ row, t, locked, onSave }) {
  const [open, setOpen] = useState(false);
  const [expected, setExpected] = useState("");
  const [reason, setReason] = useState("");
  const [busy, setBusy] = useState(false);
  const ov = row.override;
  const ok = expected !== "" && !Number.isNaN(Number(expected)) && reason.trim();
  const save = async (body) => {
    setBusy(true);
    const done = await onSave({ key: row.key, ...body });
    setBusy(false);
    if (done) { setOpen(false); setExpected(""); setReason(""); }
  };
  return (
    <div className="mt-1 space-y-1 text-[11px]" data-testid={`far-exp-override-${row.key}`}>
      {ov && (
        <div className="rounded bg-amber-50 px-1.5 py-0.5 text-amber-900 dark:bg-amber-950/30 dark:text-amber-100"
             data-testid={`far-exp-overridden-${row.key}`}>
          {fill(t(ov.pending ? "far.overridePending" : "far.overridden"),
                { by: ov.by || "", reason: ov.reason || "", computed: fmt(row.computed_expected) })}
          {!locked && (
            <button type="button" className="ms-2 underline" disabled={busy} onClick={() => save({ clear: true })}
                    data-testid={`far-exp-override-undo-${row.key}`}>{t("far.overrideUndo")}</button>
          )}
        </div>
      )}
      {!locked && !open && (
        <button type="button" className="text-sky-700 underline dark:text-sky-300" onClick={() => setOpen(true)}
                data-testid={`far-exp-override-open-${row.key}`}>{t("far.overrideBtn")}</button>
      )}
      {open && (
        <div className="flex flex-wrap items-end gap-1">
          <label className="flex flex-col">{t("far.overrideExpected")}
            <input className="w-28 rounded border px-1 py-0.5 text-end dark:bg-slate-900" inputMode="decimal" value={expected}
                   onChange={(e) => setExpected(e.target.value)} data-testid={`far-exp-override-amount-${row.key}`} /></label>
          <label className="flex min-w-[180px] flex-1 flex-col">{t("far.overrideReason")}
            <input className="rounded border px-1 py-0.5 dark:bg-slate-900" value={reason}
                   onChange={(e) => setReason(e.target.value)} data-testid={`far-exp-override-reason-${row.key}`} /></label>
          <Button size="sm" className="h-6 px-2 text-[11px]" disabled={!ok || busy}
                  onClick={() => save({ expected: Number(expected), reason: reason.trim() })}
                  data-testid={`far-exp-override-save-${row.key}`}>{t("far.overrideSave")}</Button>
          <Button size="sm" variant="ghost" className="h-6 px-2 text-[11px]" onClick={() => setOpen(false)}>{t("far.overrideCancel")}</Button>
        </div>
      )}
    </div>
  );
}
